"use client";

import React, { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourBespokeLuxuryPath() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  const [scrollOffset, setScrollOffset] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const offset = window.scrollY - (rect.top + window.scrollY) + window.innerHeight / 2;
        setScrollOffset(offset);
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="your-bespoke-luxury-path" ref={sectionRef} className={`relative w-full py-24 overflow-hidden bg-[hsl(0,0%,90%)] transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div ref={containerRef} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="flex flex-col lg:flex-row-reverse items-center gap-16 lg:gap-24">
          
          <div className="w-full lg:w-1/2 space-y-8 text-center lg:text-left z-10">
            <h2 className="text-4xl md:text-5xl font-bold leading-tight text-[hsl(218,98%,26%)] font-sans">A Unique Experience <br />of Israel</h2>

            <p className="text-lg max-w-xl mx-auto font-sans !text-[hsl(210,10%,23%)] lg:mx-0">Israel is the hub for three major monotheistic faiths. It is the cradle of Judaism and Christianity and is the third most holy city to Islam.
            <div>
            </div><div>Together, we will dive into the landscapes that have shaped the world’s most enduring stories. From the whispers of the past in the scriptures to the echoes of the Crusaders, every step is a verse in the grand narrative of this timeless land.</div></p>

            <div className="pt-4">
              <Button asChild size="lg" className="bg-[hsl(218,98%,26%)] text-white hover:bg-[hsl(218,98%,26%)]/90 px-8 py-6 text-base rounded-md shadow-lg hover:shadow-xl transition-all duration-300">
                <Link to="#" aria-label="Take the travel quiz">
                  TAKE THE QUIZ
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
            </div>
          </div>

          <div className="w-full lg:w-1/2 relative min-h-[500px] lg:min-h-[600px] flex items-center justify-center">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-white/30 rounded-full blur-3xl pointer-events-none" />

            <div className="absolute top-0 right-12 w-[70%] z-10 shadow-2xl overflow-hidden border-4 border-white transition-transform duration-100 ease-out !rounded-none" style={{
            transform: `translateY(${scrollOffset * -0.03}px)`
          }}>
              <AspectRatio ratio={4 / 5}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/luxury_travel_experience.png" alt="Luxury travel experience" className="object-cover w-full h-full hover:scale-105 transition-transform duration-700" />
              </AspectRatio>
            </div>

            <div className="absolute bottom-8 left-4 w-[55%] z-20 shadow-2xl overflow-hidden border-4 border-white transition-transform duration-100 ease-out !rounded-none" style={{
            transform: `translateY(${scrollOffset * 0.05}px)`
          }}>
              <AspectRatio ratio={1 / 1}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/city_boutique_view.png" alt="Boutique city view" className="object-cover w-full h-full hover:scale-105 transition-transform duration-700" />
              </AspectRatio>
            </div>
          </div>
        </div>
      </div>
    </section>;
}